<template>
  <div class="page">
    <v-container fluid>
      <div
        class="pa-5 mb-6"
        style="border: 1px solid #ccc; border-radius: 8px;"
      >
        <v-row align="center">
          <v-col cols="7">
            <div class="text-h5 font-weight-bold">{{ $user.fullName }}</div>
            <div class="text-body-2 text-grey-darken-1 mt-1">
              Função no Programa: {{ $user.cargo }}
            </div>
          </v-col>

          <v-col cols="4" class="text-right">
            <v-icon small class="mr-1 text-grey-darken-1">mdi-email</v-icon>
            <span class="text-body-2">{{ $user.email }}</span>
          </v-col>
        </v-row>
      </div>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Nome da Turma"
              v-model="form.filters.nome"
              outlined
              dense
              @keyup.enter="buscarAcompanhamentoDeTurmas"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              v-model="form.filters.anoSerieId"
              label="Ano/Série"
              item-text="nome"
              item-value="id"
              outlined
              dense
              :items="form.lists.listAnoSeries"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              v-model="form.filters.turnoId"
              label="Turno"
              item-text="descricao"
              item-value="id"
              outlined
              dense
              :items="form.lists.listTurnos"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              v-model="form.filters.escolaId"
              label="Escola"
              item-text="local"
              item-value="id"
              outlined
              dense
              :items="form.lists.listEscolas"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarAcompanhamentoDeTurmas()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="headers"
        :items="form.lists.listAcompanhamentoDeTurmas"
        :items-per-page="10"
        :footer-props="$footerProps"
        no-data-text="Não há registros a serem exibidos"
        item-key="id"
        :custom-sort="$customSort"
      >
        <template v-slot:[`item.acoes`]="{ item }">
          <sca-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="goToVisualizarAcompanhamento(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="goToEditarAcompanhamento(item)"
          ></sca-tooltip>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import { Dialog } from '~/commons/classes/dialog';
import AcompanhamentoDeTurmasService from '~/services/acompanhamento-de-turmas.service';
import SerieService from '~/services/serie.service';
import TurnoService from '~/services/turno.service';
import LotacaoService from '~/services/lotacao.service';

export default {
  name: "ManterAcompanhamentoDeTurmasView",
  mixins: [AcompanhamentoDeTurmasService, SerieService, TurnoService, LotacaoService],
  data: () => ({
    dialogManterAcompanhamentoDeTurmas: Dialog.Build(),
    dialogVisualizarAcompanhamentoDeTurmas: Dialog.Build(),
    form: {
      filters: {
        nome: null,
        anoSerieId: null,
        turnoId: null,
        escolaId: null,
      },
      lists: {
        listAcompanhamentoDeTurmas: [],
        listAnoSeries: [],
        listTurnos: [],
        listEscolas: [],
      }
    },
    headers: [
      { text: "Nome da Turma", align: "center", value: "nomeDaTurma" },
      { text: "Ano/Série", align: "center", value: "anoSerie" },
      { text: "Turno", align: "center", value: "turno"},
      { text: "Escola", align: "center", value: "escola"},
      { text: "Ações", align: "center", value: "acoes", sortable: false },
    ]
  }),
  methods: {
    goToEditarAcompanhamento(item) {
      if(!this.$possuiPermissao('acompanhamento.turma.editar' || !this.$possuiPermissao('acompanhamento.turma.detalhar'))){
        return this.$notifyError('Você não tem permissão para realizar essa ação!');
      }
      this.$router.push({
          name: 'Acompanhamento de Turma - Professor',
          params: { id: item.id, isView: false }
        });

    },
    goToVisualizarAcompanhamento(item) {
      if(!this.$possuiPermissao('acompanhamento.turma.detalhar')){
        return this.$notifyError('Você não tem permissão para realizar essa ação!');
      }
      this.$router.push({
        name: 'Acompanhamento de Turma - Professor',
        params: { id: item.id, isView: true }
      });
    },
    buscarAcompanhamentoDeTurmas() {
      const payload = {
        nomeDaTurma: this.form.filters.nome,
        anoSerie: this.form.filters.anoSerieId,
        turno: this.form.filters.turnoId,
        escola: this.form.filters.escolaId,
      };
      this.$buscar({ params: payload }).then(({ data }) => {
        this.form.lists.listAcompanhamentoDeTurmas = data.lista;
      });
    },
    resetForm() {
      this.$resetForm();
      this.form.lists.listAcompanhamentoDeTurmas = [];
    }
  },
  mounted() {
    const cpf = this.$user.username;
    this.$buscarSeries({ params: { ativo: true} }).then(({ data }) => (this.form.lists.listAnoSeries = data.itens));
    this.$buscarTurnos({ params: { ativo: true} }).then(({ data }) => (this.form.lists.listTurnos = data.itens));
    this.$buscarLotacoes({ params: { ativo: true, escola: true, cpfPorUsuario: cpf } }).then(({ data }) => {this.form.lists.listEscolas = data.resposta});
  }
};
</script>
